import React from "react";
import { Container } from "react-bootstrap";

const PublicNotificationSystem = ({ stream }) => {
    return (
        <>
            {stream && stream.metadata.public_announcement.announcement && (
                <Container className="my-5">
                    <div
                        style={{
                            overflow: "hidden",
                            boxShadow:
                                "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                        }}
                    >
                        <h4 className="text-center ccl-blue my-2">
                            Public Announcement
                        </h4>
                        <div
                            className="d-flex flex-column align-items-center justify-content-center"
                            dangerouslySetInnerHTML={{
                                __html: stream.metadata.public_announcement
                                    .announcement,
                            }}
                        />
                    </div>
                </Container>
            )}
        </>
    );
};

export default PublicNotificationSystem;
